// src/models/impuestoPlantillaModel.js

import pb from '../lib/pocketbase';

export async function getImpuestoPlantillas(page, perPage) {
  return await pb.collection('impuesto_plantilla').getList(page, perPage, {
    sort: '-created',  // Ordenar por fecha de creación, en orden descendente
    $autoCancel: false, // Evita que las solicitudes se cancelen automáticamente
    expand: ['empresa'], // Expande la relación de empresa si es necesario
  });
}

export async function createImpuestoPlantilla(impuestoPlantilla) {
  return await pb.collection('impuesto_plantilla').create(impuestoPlantilla);
}

export async function updateImpuestoPlantilla(id, impuestoPlantilla) {
  return await pb.collection('impuesto_plantilla').update(id, impuestoPlantilla);
}

export async function deleteImpuestoPlantilla(id) {
  return await pb.collection('impuesto_plantilla').delete(id);
}